export default __webpack_public_path__ + "media/zurb/img/home/space-circle-office-9d757c3b2522a3bc63dc2cb4aa9334bb.png";